// App.vue
<template>
  <div class="container content" :key="$route.fullPath">
    <nav class="navbar navbar-expand-sm navbar-light no-gutters text-center">
      <span v-if="flgLogin" class="ml-auto mt-2 sp-name col-2 col-sm-3 col-md-4 p-0 text-left">{{user_name}}様</span>
      <span v-else class="ml-auto col-2 col-sm-3 col-md-4 p-0"></span>

      <!-- First icon -->
      <span v-if="isJaLanguage" class="col">
        <a v-if="flgLogin" class="ml-auto btn menu-item" v-on:click="logout('home-index')">
          <img src="../assets/images/lock-solid.svg" />
          <span v-t="'app.topScreen_MainMenu_User.topScreen_MainMenu_Logout'"></span>
        </a>

        <router-link v-else to="/member/login" class="btn menu-item">
          <img src="../assets/images/lock-solid.svg" />
          <span v-t="'app.topScreen_MainMenu_nonUser.topScreen_MainMenu_Login'"></span>
        </router-link>
      </span>
      <div v-else class="col">{{ '\u00A0' }}</div>

      <!-- Second icon -->
      <span v-if="isJaLanguage" class="col">
        <a v-if="flgLogin" class="btn menu-item" v-on:click="historyPuchase('home-index')">
          <img src="../assets/images/user-solid.svg" />
          <span v-t="'app.topScreen_MainMenu_User.topScreen_MainMenu_History'"></span>
        </a>

        <router-link v-else to="/member/create" class="btn menu-item">
          <img src="../assets/images/user-solid.svg" />
           <span v-t="'app.topScreen_MainMenu_nonUser.topScreen_MainMenu_MemberRegister'"></span>
        </router-link>
      </span>
      <div v-else class="col">{{ '\u00A0' }}</div>

      <!-- Third icon -->
      <span class="col">
        <router-link to="/journey-selection/confirm-seat" class="btn menu-item">
          <img src="../assets/images/shopping-cart-solid.svg"/>
          <span v-t="'app.topScreen_MainMenu_nonUser.topScreen_MainMenu_Cart'"></span>
          <span v-show="numberSeatBooking > 0" class="button__badge">{{ numberSeatBooking }}</span>
        </router-link>
      </span>

      <!-- Fourth icon -->
      <span class="col" data-toggle="dropdown">
        <a class="btn menu-item">
          <img src="../assets/images/bars-solid.svg" />
          <span v-t="'app.topScreen_MainMenu_nonUser.topScreen_MainMenu_Menu'"></span>
        </a>
      </span>

      <div v-if="flgLogin" class="dropdown-menu dropdown-menu-left w-100 px-2">
        <router-link to="/home/index" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_firstPage'"></router-link>

        <router-link to="/journey-selection/confirm-seat" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_SeeCart'"></router-link>

        <button href="" v-on:click="historyPuchase('home-index')" class="dropdown-item my-1 btn-link" v-t="'app.topScreen_TopMenu.topScreen_History'"></button>

        <router-link to="/user/member/edit" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_InfoChange'"></router-link>

        <router-link to="/user/member/change-password" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_ChangePass'"></router-link>

        <router-link v-if="flgCardSts" to="/user/card-info/delete" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_CreditInfoChange'"></router-link>

        <router-link v-else to="/user/card-info/create" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_CreditInfoChange'"></router-link>

        <router-link :to="{ name: 'terms', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_Terms'"></router-link>

        <router-link :to="{ name: 'tokuhoso', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_DisplayTradeLaw'"></router-link>

        <a href="https://www.shinanorailway.co.jp/privacy/" target="_blank" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_AboutPersonalInfo'"></a>

        <router-link :to="{ name: 'about-cookie', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_AboutCookie'"></router-link>

        <button v-if="flgLogin" class="dropdown-item my-1" @click.prevent="logout('home-index')" v-t="'app.topScreen_TopMenu.topScreen_Logout'"></button>

        <router-link to="/user/member/unsubscribe" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_Deposit'"></router-link>
        <div class="row">
          <img class="close-btn" src="../assets/images/icon_close1_w.svg" />
        </div>
      </div>

      <div v-else class="dropdown-menu dropdown-menu-left w-100 px-2">
        <router-link :to="getHomePageUrl" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_firstPage'"></router-link>

        <router-link v-if="isJaLanguage" to="/member/create" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_Admission'"></router-link>

        <router-link v-if="isJaLanguage" to="/member/login" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_Login'"></router-link>

        <router-link to="/journey-selection/confirm-seat" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_SeeCart'"></router-link>

        <router-link to="/non/purchase-history/authenticate" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_TicketConfirm'"></router-link>

        <router-link :to="{ name: 'terms', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_Terms'"></router-link>

        <router-link :to="{ name: 'tokuhoso', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_DisplayTradeLaw'"></router-link>

        <a href="https://www.shinanorailway.co.jp/privacy/" target="_blank" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_AboutPersonalInfo'"></a>
        <router-link :to="{ name: 'about-cookie', params: getParamLang }" class="dropdown-item my-1" v-t="'app.topScreen_TopMenu.topScreen_AboutCookie'"></router-link>
        <div class="row">
          <img class="close-btn" src="../assets/images/icon_close1_w.svg" />
        </div>
      </div>
    </nav>

    <transition name="fade">

      <div id="body" class="body">
        <div v-if="loading" id="overlay">
          <clip-loader
            :loading="loading"
            :color="color"
            ></clip-loader>
        </div>
        <!-- SHINANO(splus: #64061 No.4) 2020-07-10 modify start -->
        <!-- <router-view :key="$route.fullPath"></router-view> -->
        <PageNotFound v-if="isNotFound"/>
        <router-view v-else :key="$route.fullPath"></router-view>
        <!-- SHINANO(splus: #64061 No.4) 2020-07-10 modify end -->
      </div>
    </transition>
    <b-modal id="modalCalendar" v-model="modalShow" :hide-footer="true">
      <template v-slot:modal-title>
        <div>
          <h4 v-if="timeableInfo">{{ timeableInfo.trainName }}</h4>
          <h5 v-if="timeables.length > 0 && timeableInfo">
            {{startStation.name}} {{startStation.departureTime}} <span v-t = "'modal.departure'"></span> {{endStation.name}} {{endStation.arrivalTime}} <span v-t = "'modal.arrival'"></span>
          </h5>
        </div>
      </template>
      <table class="modal-calendar-table table table-bordered">
        <tbody>
          <tr>
            <th></th>
            <th class="text-center" v-t ="'modal.arrival'"></th>
            <th class="text-center" v-t ="'modal.departure'"></th>
          </tr>
          <tr  v-for="(item, index) in timeables" v-bind:key="item.stationName">
            
            <th>{{item.stationName}}</th>
            <td class="text-center" v-if="item.isFistStation"></td>
            <td class="text-center" v-else>{{item.arrivalTime}}</td>
            <td class="text-center" v-if="item.isLastStation"></td>
            <td class="text-center" v-else>{{item.departureTime}}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <div id="footer" class="footer row col-12 text-center">
      <div class="col-12">
        <a class="mr-1 btn-change-language"
          v-on:click="loadPage($t('app.lang_Foooter_param_router'))" v-t="'app.lang_Foooter'">
        </a>

        <a class="ml-1 btn-change-language">
          <span v-on:click="loadPage($t('app.lang_Foooter_param_router2'))" v-t="'app.lang_Foooter2'"></span>
        </a>
      </div>
      <div class="col-12 footer__copyright">
        © 2020 Shinano Railway.
      </div>

    </div>

    <!-- TermsOfServicePopup b-modal -->
    <b-modal id="TermsOfServicePopup" :hide-footer="true" :hide-header="true">
      <h4 v-t="'changeReservation.cardterm'"></h4>
      <div class="row top-buffer popup-content px-0 mx-0 mb-2">
        <div class="col-12 text-danger" v-t="'changeReservation.cardcontent2'"></div>
      </div>
    </b-modal>
  </div>
</template>

<style>

</style>

<script>
import LayoutAction from "./Layout.action";
// SHINANO(splus: #64061 No.4) 2020-07-10 add start
import PageNotFound from "../shares/components/PageNotFound.vue";
// SHINANO(splus: #64061 No.4) 2020-07-10 add end
export default {
  // SHINANO(splus: #64061 No.4) 2020-07-10 add start
  components: {
    PageNotFound
  },
  // SHINANO(splus: #64061 No.4) 2020-07-10 add end
  mixins: [LayoutAction]
};
</script>
